module.exports = __webpack_public_path__ + "static/media/TUNE_4052.64c32ef1.jpg";